import React from "react";

import { Field, FormSection } from "redux-form";

import { isDynamic } from "social/DynamicCreativeToggle";
import { assetType } from "social/BuildMethodRadio";
import { useErrorBanner } from "social/utils";
import { CREATIVE_ASSET_TYPES, SOCIAL_AD_TYPES } from "utils/constants";

import SnapchatCarouselCreativeDetails,
{ SNAPCHAT_CAROUSEL_CREATIVE_DETAILS_FIELDS } from "social/carousel/SnapchatCarouselCreativeDetails";
import SnapchatCarouselDiscoverTile,
{ SNAPCHAT_CAROUSEL_DISCOVER_TILE_FIELDS } from "social/carousel/SnapchatCarouselDiscoverTile";
import SnapchatCarouselStorySnapsSection,
{ SNAPCHAT_CAROUSEL_STORY_SNAPS_FIELDS } from "social/carousel/SnapchatCarouselStorySnapsSection";

export const SNAPCHAT_CAROUSEL_BASIC_FIELDS = {
	isDynamic: {
		...isDynamic,
		unavailable: true,
	},
	assetType: {
		...assetType,
		customTip: "Ad Studio is not supported for this fomat at this time",
		disabled: true,
		input: {
			value: CREATIVE_ASSET_TYPES.PREBUILT,
		},
	},
};

const SNAPCHAT_CAROUSEL_FIELDS = {
	...SNAPCHAT_CAROUSEL_BASIC_FIELDS,
	...SNAPCHAT_CAROUSEL_CREATIVE_DETAILS_FIELDS,
	...SNAPCHAT_CAROUSEL_DISCOVER_TILE_FIELDS,
	...SNAPCHAT_CAROUSEL_STORY_SNAPS_FIELDS,
};

const adType = SOCIAL_AD_TYPES.SNAPCHAT_CAROUSEL;

export default function SnapchatStoryCarousel(props){
	const { isViewOnly, showPristineErrors } = props;

	const showPristine = showPristineErrors || ["cardCount"]; // Always show at least the card count error

	const errorMessages = useErrorBanner(adType, showPristine, SNAPCHAT_CAROUSEL_FIELDS);

	const $fields = Object.values(SNAPCHAT_CAROUSEL_BASIC_FIELDS).map((fieldProps) => {
		const disabled = isViewOnly || !!fieldProps.disabled;
		const extraProps = {
			disabled,
			showPristineErrors,
			placeholder: disabled ? '' : fieldProps.placeholder,
		};

		return (
			<Field key={fieldProps.name} {...fieldProps} {...extraProps} />
		);
	});

	return (
		<FormSection name={adType}>
			<div className="carousel-modal-content">
				{errorMessages}
				<div className="form-container">
					<div className="fields">
						{$fields}
					</div>
				</div>
			</div>
			<SnapchatCarouselCreativeDetails adType={adType} {...props} />
			<SnapchatCarouselDiscoverTile adType={adType} {...props} />
			<SnapchatCarouselStorySnapsSection adType={adType} {...props} />
		</FormSection>
	);
}

SnapchatStoryCarousel.displayName = "SnapchatStoryCarousel";
